import React from "react";
import { Container, Row, Col, Button, Spinner } from "react-bootstrap";
import { useAdvisors } from "../../context/useAdvisorsContext";

const AdvisorCard = ({ advisor }) => {
  const firstName = advisor.name ? advisor.name.split(" ")[0] : "";
  const lastName = advisor.name
    ? advisor.name.split(" ").slice(1).join(" ")
    : "";

  const whatsappNumber = advisor.whatsapp
    ? advisor.whatsapp.replace(/\D/g, "")
    : "";
  const whatsappUrl = `https://wa.me/${whatsappNumber}`;

  return (
    <Row className="align-items-stretch mb-5 py-4">
      <Col md={4} className="d-flex align-items-center justify-content-center">
        <div className="advisor-photo-container">
          {advisor.photoUrl ? (
            <img
              src={advisor.photoUrl}
              alt={advisor.name}
              className="advisor-photo"
            />
          ) : (
            <i className="bi bi-person-fill advisor-placeholder-icon"></i>
          )}
        </div>
      </Col>

      <Col md={8} className="d-flex flex-column justify-content-center ps-md-4">
        {/* Name + checkmark */}
        <div className="d-flex align-items-center justify-content-between mb-1">
          <h2 className="beba-font mb-0 advisor-name">
            <span className="text-secondary">{firstName} </span>
            <span>{lastName}</span>
          </h2>
          <img
            src="/images/check-icon.png"
            alt="Verificado"
            className="advisor-check-icon"
          />
        </div>

        {/* Subtitle */}
        <p className="text-primary mb-2 advisor-subtitle">
          Asesora verificada Puerto Rico Car Transfer
        </p>

        {/* Description */}
        <p className="advisor-description">{advisor.description_es}</p>

        {/* Tags + button wrapper — centered within description width */}
        <div className="advisor-content-block">
          {advisor.tags && advisor.tags.length > 0 && (
            <div className="d-flex align-items-center flex-wrap my-2">
              {advisor.tags.map((tag, idx) => (
                <React.Fragment key={idx}>
                  <span
                    className={`d-flex align-items-center gap-1 px-3 py-1 advisor-tag${idx === 0 ? " advisor-tag--first" : ""}`}
                  >
                    {tag.name_es}
                  </span>
                  {idx < advisor.tags.length - 1 && (
                    <div className="advisor-tag-separator"></div>
                  )}
                </React.Fragment>
              ))}
            </div>
          )}

          {/* WhatsApp button */}
          <div className="mt-3 d-flex justify-content-center">
            <Button
              variant="primary"
              href={whatsappUrl}
              target="_blank"
              rel="noreferrer"
              className="d-flex align-items-center gap-2 advisor-whatsapp-btn"
            >
              Hablar con {firstName} ahora
              <i className="bi bi-whatsapp"></i>
            </Button>
          </div>
        </div>
      </Col>
    </Row>
  );
};

const NuestrosAsesores = () => {
  const { data: advisors, isLoading, error } = useAdvisors();

  return (
    <div className="py-5">
      <Container>
        <h2 className="beba-font mb-5 asesores-section-title">
          Nuestros Asesores
        </h2>

        {isLoading && (
          <div className="d-flex justify-content-center py-5">
            <Spinner animation="border" variant="primary" />
          </div>
        )}

        {error && (
          <p className="text-danger text-center py-4">
            No se pudieron cargar los asesores. Intenta más tarde.
          </p>
        )}

        {!isLoading && !error && advisors && advisors.length === 0 && (
          <p className="text-center py-4 text-muted">
            No hay asesores disponibles en este momento.
          </p>
        )}

        {!isLoading &&
          !error &&
          advisors &&
          advisors.map((advisor) => (
            <AdvisorCard key={advisor.id} advisor={advisor} />
          ))}
      </Container>
    </div>
  );
};

export default NuestrosAsesores;
